import { useBoolean, useClipboard } from "@chakra-ui/hooks";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Box, Flex, Text } from "@chakra-ui/layout";
import { ChakraProps } from "@chakra-ui/system";
import { ReactComponent as CopyIcon } from "@/assets/icons/copy.svg";
import { Toast } from "@/components/Toast";
import { Tooltip } from "@chakra-ui/react";

interface Props {
  title: string;
  content: string;
  expandContent?: string;
  expandText?: string;
  needCopy?: boolean;
  copyText?: string;
  styles?: ChakraProps;
}

const mutiRowEllipsisStyle = (row: number) => {
  return {
    overflow: "hidden",
    "text-overflow": "ellipsis",
    display: "-webkit-box",
    "-webkit-line-clamp": `${row}`,
    "-webkit-box-orient": "vertical",
  };
};

export default function WithOriginalPrompt(props: Props) {
  const { title, content, expandContent, needCopy, expandText, copyText, styles = {} } = props;
  const [expand, expandOp] = useBoolean(false);
  const { onCopy } = useClipboard(content);

  return (
    <Box color="#999999" borderBottom="1px solid #5f5f5f" pb="8px" mb="8px" {...styles}>
      <Flex w="100%" justify="space-between" mb="8px">
        <Text fontSize="16px">{title}</Text>
        {needCopy && (
          <Flex
            cursor="pointer"
            align="center"
            fontSize="16px"
            onClick={() => {
              onCopy();
              Toast({ status: "success", title: "已复制到剪贴板" });
            }}
          >
            <CopyIcon style={{ display: "inline-block", width: "20px", height: "20px" }} />
            {copyText}
          </Flex>
        )}
      </Flex>
      <Tooltip hasArrow placement="bottom" bg="fill.icon" label={content}>
        <Text color="white" sx={mutiRowEllipsisStyle(3)} fontSize="14px" mb="8px">
          {content}
        </Text>
      </Tooltip>
      {expandContent && (
        <>
          <Flex
            w="max-content"
            align="center"
            onClick={expandOp.toggle}
            fontSize="12px"
            cursor="pointer"
            userSelect="none"
          >
            {expandText} <ChevronRightIcon transform={!expand ? "rotate(0deg)" : "rotate(90deg)"} />
          </Flex>
          <Tooltip hasArrow placement="bottom" bg="fill.icon" label={expandContent}>
            <Text fontSize="12px" h={expand ? "auto" : "0px"} sx={mutiRowEllipsisStyle(3)}>
              {expandContent}
            </Text>
          </Tooltip>
        </>
      )}
    </Box>
  );
}
